<template>
  <div class="servicesWrap">
    <div class="servicesResult">
      <img :src="merchantInfo.img" alt="" style="width: 100%;height: 130px;object-fit: cover;margin-bottom: 20px">
      <van-image width="200" height="200" :src="qrCodeUrl" />
      <div id="orderCode" ref="orderCode" class="orderCode"></div>
      <p>{{orderId}}</p>
      <div class="orderDesc">
        <p>店铺: {{merchantInfo.name}}</p>
        <p>地址: {{merchantInfo.address}}</p>
        <p>服务: {{merchantInfo.desc}}</p>
        <p v-if="orderInfo.json_data">预约时间: {{orderInfo.json_data.bookDate}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import { isWeiXin, isSafari } from '@/utils';
import QRCode from 'qrcode-generator';
import {orderEvaluate, servicesList} from "@/apis/rescue";



export default {
    data(){
        return {
            user_phone: localStorage.getItem('user_phone'),
            user_nick: localStorage.getItem('user_nick'),
            merchant_id: localStorage.getItem('merchant_id'),
            orderId: "",
            qrCodeUrl:"",
            orderInfo: {},
            merchantInfo:{
              id: '1',
              img: 'https://h5.tc-rescue.com/snServices/images/m (1).jpg',
              name: '壳牌鹏致（园洲镇鑫宝驾）',
              address: '园洲镇沙河大道69号',
              desc: "标准洗车，精致洗车，空调清洗，车内消毒"
            },
            showPicker:false,
            submitLoading:false,
        }
    },
    created(){
        this.orderId = this.$route.query.id;
        this.creatQrCode(this.orderId);
        this.getList();
    },
    mounted(){

    },
    methods: {
        getList(){
          let data = {
            page: 1,
            limit: 100,
            user_phone: this.user_phone
          }
          servicesList(data).then((res)=>{
            let resData = res.data.data;
            if(res.data.code == 1){
              this.list = resData.data.data;
              resData.data.data.forEach((item,index)=>{
                if(item.order_id == this.orderId){
                  this.orderInfo = item;
                  console.log(this.orderInfo)
                }
              })
            }else{
              this.$toast(res.data.info? res.data.info:'系统错误');
            }
          })
        },
        creatQrCode(url){
            const qr = QRCode(0, 'M')
            qr.addData(url)
            qr.make()
            this.qrCodeUrl = qr.createDataURL(8, 10)
        }
    }
}
</script>

<style lang='scss' scoped>
.servicesResult{
  text-align: center;
  p {
    font-size: 26px;
  }
  h3{
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.orderDesc{
  margin: 30px 10px 10px;
  box-shadow: 0 0 5px #ccc;
  padding: 10px;
  border-radius: 5px;
  color: #333;
}
.orderDesc p{
  font-size: 14px !important;
  line-height: 30px;
  text-align: left;
}
</style>
